import React, { useEffect, useState, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import {
  encryptString,
  createSession,
  userLogout,
  encryptFile,
} from "../../services/apiUtils";
import Loader from "../../components/common/Loader";
import { GlobalContext } from "../../GlobalDataContext/GlobalContext";
import axios from "axios";
import { API_BASE_URL } from "../../config";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import MixLogo from "../../assets/images/logo.svg";
import DriveFileRenameOutlineOutlinedIcon from "@mui/icons-material/DriveFileRenameOutlineOutlined";
import OTPAuthentication from "../../components/Abha-home/OTP-authentication";
import SidebarMenu from "../../components/Abha-home/ABHA-SidebarMenu";

const UserProfileABDM = () => {
  const [abhaProfile, setAbhaProfile] = useState(null);
  const [profilePhoto, setProfilePhoto] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [verifyMobile, setVerifyMobile] = useState(false);
  const [verifyEmail, setVerifyEmail] = useState(false);
  const [verifyWith, setVerifyWith] = useState("");
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [xToken, setXToken] = useState("");
  const [txnId, settxnId] = useState("");
  const hiddenFileInput = useRef(null);

  const navigate = useNavigate();

  // Validation functions
  const isValidMobile = (mobile) => {
    return /^[0-9]{10}$/.test(mobile);
  };

  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  // Function to fetch updated profile data
  const fetchProfile = async () => {
    try {
      setIsPageLoading(true);
      // const sessionResponse = await createSession();
      //  const accessToken = sessionResponse?.accessToken;
      // const x_token = localStorage.getItem("x_token");

      // if ( !x_token) {
      //   toast.error("Authentication tokens missing");
      //   setIsPageLoading(false);
      //   return;
      // }

      const response = await axios.get(`${API_BASE_URL}/abha/profile`, {
        headers: {
          "Content-Type": "application/json",
          // xtoken: x_token,
          // accesstoken: accessToken,
        },
      });

      const dtResponse = response.data;
      if (dtResponse.success) {
        localStorage.setItem(
          "orignalBeneficiaryData",
          JSON.stringify(dtResponse.data),
        );
        setAbhaProfile(dtResponse.data);
      }
      setIsPageLoading(false);
    } catch (error) {
      setIsPageLoading(false);
      const status = error.response?.status;
      const msg = error.response?.data?.message || error.response?.data?.error || "";
      const isAuthError =
        status === 400 ||
        status === 401 ||
        msg.toLowerCase().includes("x-token") ||
        msg.toLowerCase().includes("accesstoken") ||
        msg.toLowerCase().includes("expired");
      if (isAuthError) {
        toast.error("Session expired. Please login again.");
        setTimeout(() => {
          navigate("/login-ABHA");
        }, 1500);
      }
    }
  };

  useEffect(() => {
    const storedProfile = localStorage.getItem("orignalBeneficiaryData");
    if (storedProfile) {
      setAbhaProfile(JSON.parse(storedProfile));
    }
    // const x_token = localStorage.getItem("x_token");
    // if (x_token) {
    //   setXToken(x_token);
    //   setDataByKey("xToken", x_token);
    // }
    // Fetch fresh profile data on mount/refresh
    fetchProfile();
  }, []);
  useEffect(() => {
    const base64Prefix = "data:image/png;base64,";
    const base64String = abhaProfile
      ? base64Prefix + abhaProfile.profilePhoto
      : null;
    if (base64String) {
      setProfilePhoto(base64String);
    }
  }, [abhaProfile]);

  useEffect(() => {
    setVerifyMobile(abhaProfile?.mobile || "");
    setVerifyEmail(abhaProfile?.email || "");
  }, [profilePhoto]);

  const { setDataByKey } = useContext(GlobalContext);
  const { getDataByKey } = useContext(GlobalContext);
  useEffect(() => {
    setDataByKey("errorMessage", errorMessage);
  }, [errorMessage]);

  useEffect(() => {
    setDataByKey("txnId", txnId);
  }, [txnId]);

  useEffect(() => {
    setVerifyWith(verifyWith);
    setDataByKey("verifyWith", verifyWith);
  }, [verifyWith]);

  const handleLogout = () => {
    setTimeout(() => {
      userLogout(navigate);
    }, 5000);
  };

  const handleVerification = async (event) => {
    let verifyBy = event == "mobile" ? verifyMobile : verifyEmail;
    setVerifyWith(event);
    setErrorMessage("");
    setIsPageLoading(true);
    try {
      if (verifyBy) {
        // Encrypt mobile
        const encryptedValue = await encryptString(verifyBy);
        if (!encryptedValue) {
          setIsPageLoading(false);
          toast.error("Failed to encrypt. Please try again.");
          return;
        }

        // Create session
        // const sessionResponse = await createSession();
        // if (!sessionResponse?.accessToken) {
        //   setIsPageLoading(false);
        //   toast.error(
        //     sessionResponse?.error?.message || "Failed to create session.",
        //   );
        //   return;
        // } else {
        //   setDataByKey("accessToken", sessionResponse.accessToken);
        // }
        let param = {};
        let url = "";
        const header = {
          headers: {
            "Content-Type": "application/json",
            // xtoken: `${xToken}`,
            // accesstoken: `${getDataByKey("accessToken")}`,
          },
        };
        if (event == "mobile") {
          url = `${API_BASE_URL}/abha/update/mobile/send-otp`;
          param = {
            loginId: encryptedValue,
          };
        } else {
          url = `${API_BASE_URL}/abha/update/email/send-otp`;
          param = {
            loginId: encryptedValue,
          };
        }
        const response = await axios.post(url, param, header);
        const dtResponse = response.data;
        if (dtResponse.success) {
          setIsPageLoading(false);
          toast.success(dtResponse.data.message || "OTP Sent on your email");
          settxnId(dtResponse.data.txnId);
          setTimeout(() => {
            setShowModal(true);
          }, 2000);
        }
      } else {
        setIsPageLoading(false);
        toast.error("Please enter a valid mobile number or email");
      }
    } catch (error) {
      setIsPageLoading(false);
      // Backend returned an error response
      if (
        error.response.data.success === false &&
        error.response.data.message === "X-token expired"
      ) {
        toast.error(error.response.data.message);
        setTimeout(() => {
          handleLogout();
        }, 3000);
      } else if (
        error.response.data.message === "Unclassified Authentication Failure"
      ) {
        toast.error(error.response.data.message + ". Please try again!");
      } else {
        toast.error(
          error.response.data.message ||
            "Server error occurred. Please try again later.",
        );
      }
    }
  };

  const calculateAge = (dateString) => {
    const [day, month, year] = dateString.split("-");
    const birthDate = new Date(`${year}-${month}-${day}`);
    if (isNaN(birthDate.getTime())) {
      return null; // or return 'Invalid date'
    }

    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();

    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  const handleBrowsImage = () => {
    hiddenFileInput.current.click(); // Trigger the input click
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    try {
      if (file) {
        const ext = (file.name.split(".").pop() || "").toLowerCase();
        const allowedTypes = ["image/jpeg", "image/jpg"];
        if (
          !["jpg", "jpeg"].includes(ext) ||
          (file.type && !allowedTypes.includes(file.type.toLowerCase()))
        ) {
          toast.error(
            "Only JPG and JPEG formats are allowed for profile photo.",
          );
          e.target.value = null;
          return;
        }
        if (file.size > 100 * 1024) {
          toast.error("Maximum size allowed for profile photo is 100KB.");
          e.target.value = null;
          return;
        }
        setIsPageLoading(true);
        const encryptedImage = await encryptFile(file);
        const requestData = {
          photo: encryptedImage, // ABDM expects encrypted or base64 image
        };
        // const sessionResponse = await createSession();
        //  const accessToken = sessionResponse?.accessToken;
        // const xToken = localStorage.getItem("x_token");
        const response = await axios.patch(
          `${API_BASE_URL}/abha/profile/photo`,
          requestData,
          {
            headers: {
              "Content-Type": "application/json",
              // xtoken: xToken,
              // accesstoken: accessToken,
            },
          },
        );
        const dtResponse = response.data;
        if (dtResponse.success) {
          localStorage.setItem(
            "orignalBeneficiaryData",
            JSON.stringify(dtResponse.data),
          );
          setIsPageLoading(false);
          toast.success("Photo updated successfully!");
        } else {
          setIsPageLoading(false);
          toast.error("Profile photo update failed");
        }
      } else {
        toast.error("Error uploading photo");
      }
    } catch (error) {
      setIsPageLoading(false);
      // Backend returned an error response
      if (
        error.response.data.success === false &&
        error.response.data.message === "X-token expired"
      ) {
        toast.error(error.response.data.message);
        setTimeout(() => {
          handleLogout();
        }, 3000);
      } else if (
        error.response.data.message === "Unclassified Authentication Failure"
      ) {
        toast.error(error.response.data.message + ". Please try again!");
      } else {
        toast.error(
          error.response.data.message ||
            "Server error occurred. Please try again later.",
        );
      }
    }
  };

  return (
    <>
      <ToastContainer />
      {isPageLoading && <Loader />}
      {showModal && (
        <OTPAuthentication
          onClose={() => setShowModal(false)}
          setShowModal={setShowModal}
          onVerificationSuccess={fetchProfile}
        />
      )}
      <div className="mainFlow">
        <Navbar />
        <div className="container">
          <div className="pranHealtnMainUserFlow">
            <div className="abha-paranLogo">
              <img src={MixLogo} />
            </div>
            <div className="userFlowAdharVer">
              {/* <div className="flowTitle">
                                <h4>Set your PHR (ABDM) Address</h4>
                                <p>Basic profile information is captured from Aadhar</p>
                            </div> */}
              <div className="user-profile-dashboard">
                {/* <div className="leftDashbirdMenu">
                                    <ul>
                                        <li><a href="/abha-Card">ABHA Card</a></li>
                                        <li><a className="active" href="/my-profile">My Profile</a></li>
                                        <li><a href="/manage-ABHA-profile">Manage ABHA Profile</a></li>
                                        <li><a href="/manage-password">Manage Password</a></li>
                                        <li><a href="/delete-deactivate-account">Delete/Deactivate</a></li>
                                        <li><a href="/re-KYC">Re-KYC</a></li>
                                        <li><a href="/login-ABHA">Logout</a></li>
                                    </ul>
                                </div> */}
                <SidebarMenu activePage="profile" />
                <div className="centerBoard">
                  <div className="rightProfileMain withoutBorder myProfilePage">
                    {/* <div className="profileBanner">
                                            <img src={ProfleBanner} />
                                        </div> */}
                    <div className="profileUser">
                      <div className="profileContent">
                        <h4>{abhaProfile ? abhaProfile.name : ""}</h4>
                        <p>
                          {abhaProfile
                            ? abhaProfile.gender == "M"
                              ? "Male"
                              : abhaProfile.gender == "F"
                                ? "Female"
                                : ""
                            : ""}{" "}
                          -{" "}
                          {calculateAge(
                            abhaProfile
                              ? abhaProfile.dayOfBirth +
                                  "-" +
                                  abhaProfile.monthOfBirth +
                                  "-" +
                                  abhaProfile.yearOfBirth
                              : "1970",
                          )}{" "}
                          year old
                        </p>
                      </div>
                    </div>
                    <div className="abhaNumber">
                      <h4>Address</h4>
                      <p>{abhaProfile ? abhaProfile.address : ""}</p>
                    </div>
                    <div className="phrAddress">
                      <div className="feilds mb-2">
                        <label>Mobile Number</label>
                        <div style={{ position: "relative" }}>
                          <input
                            type="text"
                            value={verifyMobile}
                            onChange={(e) => {
                              const value = e.target.value.replace(/\D/g, ""); // Only digits
                              if (value.length <= 10) {
                                setVerifyMobile(value);
                              }
                            }}
                            className={`form-control ${abhaProfile?.mobileVerified ? "is-valid" : "is-invalid"}`}
                            placeholder="Enter Mobile Number"
                            maxLength={10}
                            style={{ paddingRight: "40px" }}
                          />
                          {isValidMobile(verifyMobile) && (
                            <i
                              className="material-icons"
                              style={{
                                position: "absolute",
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                color: "#4CAF50",
                                fontSize: "20px",
                              }}
                            >
                              check
                            </i>
                          )}
                        </div>
                        {verifyMobile && !isValidMobile(verifyMobile) && (
                          <p
                            style={{
                              color: "red",
                              fontSize: "12px",
                              marginTop: "5px",
                            }}
                          >
                            Please enter a valid 10-digit mobile number
                          </p>
                        )}
                        {abhaProfile?.mobileVerified &&
                          isValidMobile(verifyMobile) && (
                            <span
                              className="verify"
                              onClick={() => handleVerification("mobile")}
                            >
                              Verify
                            </span>
                          )}
                        {errorMessage && verifyWith == "mobile" && (
                          <p style={{ color: "red" }}>{errorMessage}</p>
                        )}
                      </div>
                      <div className="feilds">
                        <label>Email Address</label>
                        <div style={{ position: "relative" }}>
                          <input
                            type="text"
                            onChange={(e) => setVerifyEmail(e.target.value)}
                            value={verifyEmail}
                            placeholder="Enter Email Address"
                            style={{ paddingRight: "40px" }}
                          />
                          {isValidEmail(verifyEmail) && (
                            <i
                              className="material-icons"
                              style={{
                                position: "absolute",
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                color: "#4CAF50",
                                fontSize: "20px",
                              }}
                            >
                              check
                            </i>
                          )}
                        </div>
                        {verifyEmail && !isValidEmail(verifyEmail) && (
                          <p
                            style={{
                              color: "red",
                              fontSize: "12px",
                              marginTop: "5px",
                            }}
                          >
                            Please enter a valid email address
                          </p>
                        )}
                        {abhaProfile?.mobileVerified &&
                          isValidEmail(verifyEmail) && (
                            <span
                              className="verify"
                              onClick={() => handleVerification("email")}
                            >
                              Verify
                            </span>
                          )}
                        {errorMessage && verifyWith == "email" && (
                          <p style={{ color: "red" }}>{errorMessage}</p>
                        )}
                      </div>
                    </div>
                    <div className="abhaNumber">
                      <h4>District</h4>
                      <p>{abhaProfile ? abhaProfile.districtName : ""}</p>
                    </div>
                    <div className="abhaNumber dateOfBirthday">
                      <div>
                        <h4>State</h4>
                        <p>{abhaProfile ? abhaProfile.stateName : ""}</p>
                      </div>
                      <div>
                        <h4>Pincode</h4>
                        <p>{abhaProfile ? abhaProfile.pincode : ""}</p>
                      </div>
                    </div>
                    {/* <div className="scanner">
                                            <div className="scannerImg">
                                                <img src={Scanner} />
                                            </div>
                                            <div className="scannerShare">
                                                <p>Share <i class="material-icons">
                                                    share
                                                </i></p>
                                            </div>
                                        </div> */}
                  </div>
                </div>
                <div className="rightDashBord">
                  <div className="profileImg">
                    <img src={profilePhoto} />
                    {/* Hidden Input */}
                    <input
                      type="file"
                      ref={hiddenFileInput}
                      accept=".jpg,.jpeg,image/jpeg"
                      onChange={handleFileChange}
                      style={{ display: "none" }}
                    />
                    <span className="icon" onClick={handleBrowsImage}>
                      <DriveFileRenameOutlineOutlinedIcon />
                    </span>
                    <p>
                      Please upload JPG, JPEG file types. Maximum size allowed
                      for the attachment is 100KB.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bottomDashboard">
                {/* <div className="saveBtnProfile justify-content-center">
                                    <button className="custBtn btnThems">Cancel</button>
                                    <button className="custBtn disabled">Save</button>
                                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default UserProfileABDM;
